import { createContext, useContext, type ReactNode } from 'react';

const PageTabsContext = createContext(false);

/** 페이지 헤더의 탭 슬롯 안에서만 묶음형 선택 표면을 적용합니다. */
export function PageTabsProvider({ children }: { children: ReactNode }) {
  return <PageTabsContext.Provider value>{children}</PageTabsContext.Provider>;
}

export function usePageTabs(): boolean {
  return useContext(PageTabsContext);
}
